var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGifBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34 20.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#1d3152;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.32,10.91V7.42h4.1V4.64h-4.1V2.77H24V0H16V10.91Zm-4.65,0V0H12V10.91Zm-8.85,0a9.15,9.15,0,0,0,2.4-.34,7.08,7.08,0,0,0,2.15-1V5.17H7.31V7.81A3.25,3.25,0,0,1,6,8.06a2.42,2.42,0,0,1-1.81-.71,2.66,2.66,0,0,1-.67-1.9,2.57,2.57,0,0,1,.68-1.9,2.46,2.46,0,0,1,1.85-.7A3,3,0,0,1,8.42,4l2.25-2a5.33,5.33,0,0,0-2-1.5A7.06,7.06,0,0,0,5.9,0,6.61,6.61,0,0,0,2.85.69,5.12,5.12,0,0,0,.75,2.63,5.36,5.36,0,0,0,0,5.45,5.37,5.37,0,0,0,.75,8.28a5.26,5.26,0,0,0,2.08,1.94A6.37,6.37,0,0,0,5.82,10.91Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 34,
    height: 20.91
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifBlue);
export default __webpack_public_path__ + "static/media/GIF_blue.633dcc9f0c962f097a1033661a186011.svg";
export { ForwardRef as ReactComponent };